import { cn } from '@/lib/utils'
import { ChartSquareIcon, ClockIcon, GiftIcon, MoneysBoldIcon, WalletBoldSmallIcon } from './icons'
import { Button } from '../ui/button'

const RECENT_CLAIMS = [
	{ date: '23.04.2026', amount: '12,5 SOL', colorClass: 'bg-purple' },
	{ date: '23.04.2026', amount: '567,89 USDT', colorClass: 'bg-success' },
	{ date: '23.04.2026', amount: '287,02 USDT', colorClass: 'bg-info' },
]

interface QuickAction {
	icon: typeof WalletBoldSmallIcon
	title: string
	description: string
	gradientClass: string
}

const QUICK_ACTIONS: QuickAction[] = [
	{
		icon: WalletBoldSmallIcon,
		title: 'Deposit',
		description: 'Add funds to your wallet',
		gradientClass: 'from-info to-[hsl(var(--accent-green))]',
	},
	{
		icon: MoneysBoldIcon,
		title: 'Withdraw',
		description: 'Cash out your winnings',
		gradientClass: 'from-info to-[hsl(var(--accent-green))]',
	},
	{
		icon: ChartSquareIcon,
		title: 'Stake BCY',
		description: 'Earn passive rewards',
		gradientClass: 'from-[hsl(var(--accent-purple))] to-purple',
	},
	{
		icon: GiftIcon,
		title: 'Claim Rewards',
		description: 'Collect your earnings',
		gradientClass: 'from-warning to-warning/70',
	},
]

export function RewardsAndActions() {
	return (
		<section className='flex flex-col gap-4 lg:flex-row'>
			<div className='flex min-w-0 flex-1 flex-col gap-4 rounded-[14px] border border-border bg-card p-4 shadow-[0_4px_12px_0_hsl(var(--background)/0.2)] lg:flex-row'>
				<div className='relative flex flex-1 flex-col items-center justify-center gap-4 overflow-hidden rounded-xl bg-background px-6 py-6 text-center'>
					<div className='pointer-events-none absolute inset-0 bg-gradient-to-b from-warning/30 to-transparent opacity-40' />
					<span className='relative text-sm font-medium text-foreground'>Total Claimable</span>
					<span className='relative text-3xl font-extrabold tracking-[-0.015em] text-foreground'>$ 12 750,89</span>
					<Button type='button' className='w-full'>
						Claim All
					</Button>
				</div>

				<div className='flex flex-1 flex-col gap-3 rounded-xl bg-background p-3'>
					<div className='flex items-center gap-2 text-muted-foreground'>
						<ClockIcon className='h-5 w-5 text-subtle-foreground' />
						<span className='text-sm'>Next Payout In</span>
						<span className='ml-auto text-sm font-semibold text-primary'>03:24:12</span>
					</div>
					<span className='text-xs font-medium text-foreground'>Recent Claims</span>
					<div className='flex flex-col'>
						{RECENT_CLAIMS.map((claim, i) => (
							<div key={i} className={cn('flex items-center gap-3 rounded-lg px-2 py-1.5', i % 2 === 1 && 'bg-foreground/[0.03]')}>
								<span className={cn('h-1.5 w-1.5 rounded-full', claim.colorClass)} />
								<span className='text-xs text-muted-foreground'>{claim.date}</span>
								<span className='ml-auto text-xs font-medium text-foreground'>{claim.amount}</span>
							</div>
						))}
					</div>
				</div>
			</div>

			<div className='grid min-w-0 flex-1 grid-cols-1 gap-4 sm:grid-cols-2'>
				{QUICK_ACTIONS.map((action) => (
					<div
						key={action.title}
						className='relative flex flex-col items-center justify-center gap-1 overflow-hidden rounded-xl border border-border bg-secondary px-4 py-4 text-center'
					>
						<div className={cn('pointer-events-none absolute inset-0 bg-gradient-to-b opacity-20', action.gradientClass)} />
						<span className='relative flex items-center gap-2 text-sm font-medium text-foreground'>
							<action.icon className='h-[18px] w-[18px]' />
							{action.title}
						</span>
						<span className='relative text-xs text-muted-foreground'>{action.description}</span>
					</div>
				))}
			</div>
		</section>
	)
}
